import createLucideIcon from '../createLucideIcon';

const ArrowDownToLine = createLucideIcon('ArrowDownToLine', [
  ['line', { x1: '12', x2: '12', y1: '17', y2: '3', key: '1abdup' }],
  ['polyline', { points: '6 11 12 17 18 11', key: 'ryj4lu' }],
  ['path', { d: 'M19 21H5', key: '150jfl' }],
]);

export default ArrowDownToLine;
